import { createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from './actions';
import { SnacksState } from './types';

export const snacksInitialState: SnacksState = {
  data: [],
  closing: false
};

const snacksReducer = createReducer<SnacksState>(snacksInitialState, {
  [actions.CREATE_SNACK]: (state, action) => {
    state.data = [...state.data, action.payload];
  },
  [actions.CLOSING_SNACK]: state => {
    state.closing = true;
  },
  [actions.REMOVE_SNACK]: (state, action) => {
    state.data = action.payload;
    state.closing = false;
  },
  [switchAccountSuccess.type]: () => snacksInitialState
});

export default snacksReducer;
